<template>
  <div class="grid bg-white">
    <div class="grid-title">
      <h4 class="heading semi-bold">All Suppliers</h4>
    </div>
    <div class="grid-body">
      <div class="row">
        <div class="col-md-4">
          <div class="input-group transparent">
            <span class="input-group-addon">
              <i class="fa fa-search" aria-hidden="true"></i>
            </span>
            <input
              id="supplier-filter"
              type="text"
              class="form-control search-table"
              placeholder="Keyword ..."
            />
          </div>
        </div>
        <div class="header-button-container col-md-8">
          <!-- <router-link :to="{ path: '/fabric/suppliers/import' }" class="btn shadow btn-white create-new-button">
                        <i class="fa fa-upload" aria-hidden="true"></i> Import Data
                    </router-link> -->
          <router-link
            :to="{ name: 'fabric_suppliers_create' }"
            class="btn shadow btn-primary create-new-button"
            v-if="!isReadOnlyUser"
          >
            <i class="fa fa-plus-circle" aria-hidden="true"></i> Create New
            Supplier
          </router-link>
        </div>
      </div>

      <div class="row mt-20">
        <div class="col-md-12">
          <div class="table-responsive">
            <vue-good-table
              mode="remote"
              @on-selected-rows-change="selectionChanged"
              :totalRows="totalRecords"
              :isLoading.sync="isLoading"
              :selectOptions="{
                enabled: true,
                selectOnCheckboxOnly: true,
              }"
              :pagination-options="{
                enabled: true,
                mode: 'pages',
              }"
              styleClass="table table-bordered data-table"
              :rows="rows"
              :columns="columns"
            >
              <template slot="table-row" slot-scope="props">
                <span v-if="props.column.field == 'contact_person_name'">
                  {{ props.row.contact_person_title }}
                  {{ props.row.contact_person_name }}
                </span>
                <span v-else-if="props.column.field == 'action_id'">
                  <router-link
                    :to="{
                      name: 'fabric_suppliers_update',
                      params: { supplier_id: props.row.id },
                    }"
                    class="btn btn-success"
                    v-if="!isReadOnlyUser"
                  >
                    <i class="fa fa-edit" aria-hidden="true"></i> Edit
                  </router-link>

                  <button
                    type="button"
                    class="btn btn-danger"
                    @click="
                      deleteSupplier(props.row.id, props.row.originalIndex)
                    "
                    v-if="!isReadOnlyUser"
                  >
                    <i class="fa fa-trash" aria-hidden="true"></i>
                  </button>
                </span>
                <span v-else-if="props.column.field == 'delivery_efficiency'">
                  {{ props.row.delivery_efficiency }}
                </span>
                <span v-else-if="props.column.field == 'fabrics'">
                  {{ props.row.fabrics.join(", ") }}
                </span>
                <span v-else-if="props.column.field == 'email'">
                  <span>
                    <a :href="'mailto:' + props.row.email">{{
                      props.row.email
                    }}</a>
                  </span>
                </span>
                <span v-else-if="props.column.field == 'phone'">
                  <span>
                    <a :href="'tel:' + props.row.phone">{{
                      props.row.phone
                    }}</a>
                  </span>
                </span>
                <span v-else>
                  {{ props.formattedRow[props.column.field] }}
                </span>
              </template>
              <div slot="selected-row-actions">
                <button
                  class="btn btn-danger"
                  @click="batchDelete()"
                  style="margin-top: -10px"
                >
                  <i class="fa fa-trash" aria-hidden="true"></i>
                </button>
              </div>
            </vue-good-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { TableHelper } from "@/pages/Tools/TableHelper.js";
import { VueGoodTable } from "vue-good-table";
import Fabric from "@/pages/Tools/Fabric";
import * as $ from "jquery";

export default {
  mounted() {
    this.isReadOnlyUser = this.$auth.user().role === "read_only";
    new TableHelper({
      parent: this,
      endpoint: "/v2/fabrics/suppliers",
      filterSelector: "#supplier-filter",
      filterColumns: [
        "id",
        "name",
        "code",
        "phone",
        "email",
        "contact_person_name",
      ],
      sort: {
        id: "asc",
        name: "desc",
      },
    });
  },
  components: {
    VueGoodTable,
  },
  data() {
    return {
      isLoading: false,
      isReadOnlyUser: false,
      columns: [
        {
          label: "ID",
          field: "id",
          tdClass: "text-center",
          thClass: "text-center",
        },
        {
          label: "Name",
          field: "name",
          tdClass: "text-center",
          thClass: "text-center",
        },
        {
          label: "Code",
          field: "code",
          tdClass: "text-center",
          thClass: "text-center",
        },
        {
          label: "Fabrics",
          field: "fabrics",
          tdClass: "text-left",
          thClass: "text-left",
          sortable: false,
        },
        {
          label: "Delivery time in Weeks",
          field: "delivery_efficiency",
          tdClass: "text-center",
          thClass: "text-center",
          width: "150px",
        },
        {
          label: "Phone",
          field: "phone",
          tdClass: "text-center",
          thClass: "text-center",
          //width: '200px',
        },
        {
          label: "Email",
          field: "email",
          type: "number",
          tdClass: "text-center",
          thClass: "text-center",
        },
        {
          label: "Contact Person",
          field: "contact_person_name",
          tdClass: "text-center",
          thClass: "text-center",
          //width: '200px',
        },
        {
          label: "Action",
          field: "action_id",
          sortable: false,
          tdClass: "text-center",
          thClass: "text-center",
          width: "15%",
        },
      ],
      rows: [],
      totalRecords: 0,
      saveType: "create",
      saveId: null,
      saveIndex: null,
      selectedRows: [],
    };
  },
  methods: {
    /**
     * This function convert the long fabric ID to short ones
     * This function is internally called by the TableHelper before
     */
    preProcessCollection(suppliers) {
      return suppliers.map((supplier) => {
        supplier.fabrics = supplier.fabrics.map((fabricID) => {
          return Fabric.getCode(fabricID);
        });
        return supplier;
      });
    },
    deleteSupplier(id, index) {
      var self = this;
      Swal.fire({
        title: "Are you sure?",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.value) {
          axios
            .delete("/v2/fabrics/suppliers/" + id)
            .then(function (res) {
              if (res.data.status === "OK") {
                self.rows.splice(index, 1);
                Swal.fire("Deleted!", "", "success");
              }
            })
            .catch(function (error) {
              if (error.response.status === 403) {
                toastr.error(
                  "Not authorized, please ensure that you have the required permissions."
                );
              } else {
                toastr.error(
                  "There was some errors, please correct and try again, or contact the admins"
                );
              }
            });
        }
      });
    },
    batchDelete() {
      let self = this;
      let rows = self.selectedRows;
      let deleteIds = [];
      $.each(rows, function (k, v) {
        deleteIds.push(v.id);
      });
    },
    selectionChanged(params) {
      this.selectedRows = params.selectedRows;
    },
  },
};
</script>

<style scoped>
@import "~sweetalert2/dist/sweetalert2.min.css";

.search-table {
  width: 300px;
}

.modal-header .close {
  margin-top: -20px;
}

.header-button-container {
  text-align: right;
  height: 100%;
}

.create-new-button {
  margin-top: 50px;
  height: 100%;
}

.btn-primary {
  height: 37.5px;
  border: 1px;
  /*padding-top: 8.5px;*/
  /*margin-bottom: -1px;*/
}

.fa-plus-circle {
  padding-top: 4.5px;
}

.vgt-checkbox-col {
  color: blue;
}
</style>
